import { Text, VStack } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';

import { useQuantityFormat } from '../../../hooks/use-quantity-format';
import { ColumnComponentProps } from '../../../types/activity-column-types';

export function QuantityColumn({
  info,
}: ColumnComponentProps<BackofficeActivitiesOrderItem, number | undefined>) {
  const { quantity, multiplier } = useQuantityFormat(info.row.original);

  if (multiplier && multiplier !== 1) {
    return (
      <VStack alignItems="flex-start">
        <Text fontSize="sm" fontWeight="400">
          {quantity}
        </Text>
        <Text color="gray.500" fontSize="sm" fontWeight="400">
          (Kelipatan: {multiplier})
        </Text>
      </VStack>
    );
  }

  return (
    <Text fontSize="sm" fontWeight="400">
      {quantity}
    </Text>
  );
}
